module.exports = __webpack_public_path__ + "img/aguachalco.58c3da9f.jpg";